import { Link } from "react-router-dom";

import Logo from "../../../assets/images/logo.png";
import Button from "../../../app/universalComponents/Button";
import EventsNav from "./EventsNav";
import UserBadge from "./UserBadge";

export default function Sidebar({
  eventsList,
  organiser,
  onNavigate,
  onCreateEvent,
}) {
  function handleNavigationClick(event) {
    const clickableElement = event.target.closest("a, button");

    if (clickableElement) {
      onNavigate?.();
    }
  }

  return (
    <>
      <header
        className="flex items-end justify-center border-b py-2"
        onClickCapture={handleNavigationClick}
      >
        <Link
          to="/"
          className="flex items-end justify-center"
          aria-label="Go to homepage"
        >
          <img
            src={Logo}
            alt="Tickets.NP logo"
            className="h-12"
          />

          <span className="text-xl font-bold italic tracking-tight">
            Tickets.NP
          </span>
        </Link>
      </header>

      <Button
        disabled={organiser?.status !== "active"}
        onClick={onCreateEvent}
        className="mx-4 mt-4 text-center text-sm"
      >
        Create Event
      </Button>

      <div
        className="min-h-0 flex-1 overflow-y-auto"
        onClickCapture={handleNavigationClick}
      >
        <EventsNav eventsList={eventsList} />
      </div>

      <UserBadge
        organiserName={organiser?.name}
        organiserLogo={organiser?.logo}
      />

      <footer className="border-t p-2 text-center text-xs text-gray-500">
        © 2026 npSolved
      </footer>
    </>
  );
}